module.exports = __webpack_public_path__ + "static/role-of-it@2x-d7412a0ae4108456ac0874d5517e4378.jpg";